import React, { Component } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

// import styles from './styles';
class LoadingView extends Component {

// componentDidMount() 
  render = () => {
      return (
        <div> Loading.. </div>
      );
  }

}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(LoadingView);
